module.exports = __webpack_public_path__ + "static/media/grilled.dd195792.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/grilled.JPG
// module id = 567
// module chunks = 0